const MessageLayout = () => import(/* webpackChunkName: "message" */'@/components/messages/MsgsLayout')
const MsgsList = () => import(/* webpackChunkName: "message" */'@/components/messages/MsgsList')
const MsgsDetail = () => import(/* webpackChunkName: "message" */'@/components/messages/MsgsDetail')

export default {
  // name: 'order',
  path: 'message',
  component: MessageLayout,
  children: [
    {
      name: 'messageList',
      path: 'messageList',
      component: MsgsList,
      meta: {
        module: 'message',
      },
    },
    {
      name: 'messageDetail',
      path: 'messageList/messageDetail',
      component: MsgsDetail,
      meta: {
        module: 'message',
      },
    },
    {
      name: 'suggestions',
      path: 'messageList/suggestions',
      component: () => import(/* webpackChunkName: "message" */'@/components/messages/suggestions'),
      meta: {
        module: 'message',
      },
    },
    {
      path: '/',
      redirect: {name: 'messageList'},
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/message.js